<template id='content'>
	<div class="bg">
		<div class="top">
			<div class="top_c">
				<div>找回密码</div>
			</div>
		</div>
		<div class="bottom">
			<div class="b_t">找回密码</div>
			<div class="b_c">
				<div class="clearfix">
					<div class="b_c_1" v-for="(stepitem,idx) in steplist" :key="idx">
						<div class="b_c_1_bg" :class="{background:idx==step,background1:idx<step}"></div>
						<div class="b_c_1_c" :class="{background:idx==step,background1:idx<step}">{{stepitem.id+1}}</div>
						<div class="b_c_1_t" :class="{color:idx==step,color1:idx<step}">{{stepitem.text}}</div>
					</div>
				</div>
			</div>
			<div class="b_c_box clearfix">
				<img style="width:50px;height:50px;" src="../../assets/img/complete.png" alt="">
				<div style="text-align:center;">
					<img src="" alt="">
				</div>
				<div>
					<span style="color:#757575;">新密码设置成功！赶紧<i style="color:#ea0036;" @click="goto" href="">重新登录</i>吧~</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import Qs from 'qs'
	import { ip,sha1 } from '../../assets/js/public.js'
  import bus from '../../assets/js/eventBus'

	export default {
		data () {
			return {
				steplist:[{'id':0,'text':'填写账户名'},{'id':1,'text':'验证身份'},{'id':2,'text':'设置新密码'},{'id':3,'text':'完成'}],
				step:null
			}
		},
		mounted:function () {
			var t_=this
			t_.step=t_.$route.query.step-1
		},
		methods:{
			goto:function(){
				var href=this.$router.resolve({name:'member',query:{listId:-1}})
              window.open(href.href,'_blank')
				// this.$router.push({
				// 	path: '/LoginHome?state=1',
				// 	query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
				// })
				// this.$router.go(0);
			}
		}
	}
</script>

<style>
	html,body{
    height: 100%;
  }
	.clearfix {
		overflow: auto;
		_height: 1%;
	}
	.fl{
		float: left;
	}
	.bg{
		background: #f5f5f5;
		height: 100%;
	}
	.top{
		background: #fff;
		height: 116px;
		border-bottom: 3px solid #ff2c4c;
	}
	.top_c{
		width: 990px;
		height: 116px;
		margin: 0 auto;
	}
	.top_c div{
		font-size: 24px;
		color:#2d2d2d;
		margin-left: 20px;
		line-height: 96px;
	}
	.bottom{
		width: 990px;
		height: 530px;
		background: #fff;
		margin: 0 auto;
	}
	.b_t{
		height: 44px;
		padding: 24px 0 0 21px;
		color:#666;
		font-weight: 900;
	}
	.b_c{
		width: 634px;
		margin: 0 auto;
		overflow: hidden;
	}
	.b_c_1{
		width: 25%;
		height: 40px;
		position: relative;
		float: left;
		overflow: hidden;
	}
	.b_c_1_bg{
		width: 100%;
		height: 5px;
		background: #cdcdcd;
		position: absolute;
		top: 10px;
	}
	.b_c_1_c{
		width: 23px;
		height: 23px;
		border-radius: 50%;
		background: #cdcdcd;
		color: #fff;
		text-align: center;
		line-height: 23px;
		margin: 0 auto;
		position: relative;
	}
	.b_c_1_t{
		color:#666;
		text-align: center;
		margin-top: 1px;
	}
	.background{
		background: #7abd54;
	}
	.color{
		color:#7abd54;
	}
	.color1{
		color:#cbedb7;
	}
	.background1{
		background:#cbedb7;
	}
	.b_c_box{
		text-align: center;
		width: 240px;
		margin: 33px auto;
	}
	.b_c_box i{
		cursor: pointer;
	}
	.b_c_box span{
		line-height: 23px;
		margin-left: 25px;
	}
</style>


// WEBPACK FOOTER //
// src/components/setPassword/setPWD4.vue